import { useState } from "react";
import { ORTHO_ICD10, ORTHO_CPT } from '../data/orthoData';

export default function CodePicker({ type, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = type === "icd10" ? ORTHO_ICD10 : ORTHO_CPT;
  const filtered = list.filter(x =>
    (x.code + x.desc).toLowerCase().includes(q.toLowerCase()) && !selected.includes(x.code)
  ).slice(0, 8);
  const color = type === "icd10" ? "#4ade80" : "#60a5fa";
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button onClick={() => setOpen(!open)} style={{
        background: "rgba(255,255,255,0.05)", border: "1px dashed rgba(255,255,255,0.2)",
        color: "rgba(255,255,255,0.5)", borderRadius: 6, padding: "2px 10px", cursor: "pointer", fontSize: 11,
      }}>+ Add {type === "icd10" ? "ICD-10" : "CPT"}</button>
      {open && (
        <div style={{
          position: "absolute", zIndex: 100, top: "calc(100% + 4px)", left: 0,
          background: "#0f1923", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10,
          width: 320, boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
        }}>
          <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search code or keyword…"
            style={{ width: "100%", padding: "10px 14px", background: "transparent", border: "none", borderBottom: "1px solid rgba(255,255,255,0.1)", color: "#fff", fontSize: 12, outline: "none", boxSizing: "border-box" }} />
          {filtered.map(x => (
            <div key={x.code} onClick={() => { onChange([...selected, x.code]); setQ(""); setOpen(false); }}
              style={{ padding: "8px 14px", cursor: "pointer", display: "flex", gap: 8, alignItems: "baseline" }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.06)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <span style={{ color, fontFamily: "'IBM Plex Mono',monospace", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{x.code}</span>
              <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}>{x.desc}</span>
            </div>
          ))}
          {filtered.length === 0 && <div style={{ padding: "10px 14px", color: "rgba(255,255,255,0.3)", fontSize: 11 }}>No matches found</div>}
        </div>
      )}
    </div>
  );
}
